// extracted by mini-css-extract-plugin
module.exports = {"clear-expanded-section":"AllocationCell_clear-expanded-section__2MDe6","with-top-padding":"AllocationCell_with-top-padding__3s4RD"};